module.exports = __webpack_public_path__ + "img/symbol_11.021e2445.png";